import React, { useState } from 'react'
import { Form, Collapse, Row, Col, Button } from 'react-bootstrap';
import { FaArrowAltCircleDown, FaArrowAltCircleUp, FaTimesCircle } from 'react-icons/fa'
import CheckButton from '../../components/CheckButton';
import CustomCheck from '../../components/CustomCheck';
import CustomModal from '../../components/CustomModal';
import MultiRangeSlider from '../../components/multiRangeSlider';
import SearchFormFiltersDistance from './SearchFormFiltersDistance';
import SearchFormFiltersPrice from './SearchFormFiltersPrice';
import SearchFormFiltersBookableNowOnly from './SearchFormFiltersBookableNowOnly';
import SearchFormFiltersReservableOnly from './SearchFormFiltersReservableOnly'
import SearchFormFiltersDeliverableOnly from './SearchFormFiltersDeliverableOnly';

const SearchFormFilters = ({ options, request, submitRef }) => {
    const {
        vehicle_types
    } = options;

    const {
        distance,
        show_bookable_now_only,
        show_reservable_only,
        show_deliverable_only,
        filters = {},
        for_sales
    } = request;

    const [openVehicle, setOpenVehicle] = useState(false);
    const [openAccommodations, setOpenAccommodations] = useState(false);
    const [openFeatures, setOpenFeatures] = useState(false);
    const [minLen, setMinLen] = useState(parseInt(filters.vehicle_length_gteq) || '');
    const [maxLen, setMaxLen] = useState(parseInt(filters.vehicle_length_lteq) || '');
    const [minWeight, setMinWeight] = useState(parseInt(filters.gvw_gteq) || '');
    const [maxWeight, setMaxWeight] = useState(parseInt(filters.gvw_lteq) || '');
    const [showMoreFiltersModal, setShowMoreFiltersModal] = useState(false);

    return (<>
        <Row className="outer filter-container filter-wrap">
            <a
                type="button"
                className="btn btn-mod btn-border btn-circle btn-small price filtering-btn"
                onClick={() => { setShowMoreFiltersModal(true); }}>
                More Filters
            </a>
            <a href={`/${for_sales ? 'rv-sales' : 'rv-rentals'}/search?clear=true`} className="btn btn-mod btn-border btn-circle btn-small price filtering-btn"> <FaTimesCircle style={{ marginRight: "8px" }} />clear</a>
        </Row>

        <CustomModal
            show={showMoreFiltersModal}
            onClose={() => {
                setShowMoreFiltersModal(false);
            }}
            title={`More Filters`}
            footerContent={
                <Button type="submit" className="btn btn-green" style={{ padding: "5px 20px", margin: "auto" }}>Apply Filter</Button>
            }
        >
            <div className="modal-body mx-3" style={{ textAlign: 'left' }}>
                <div className="btn-custom-mod-wrapper" >
                    <SearchFormFiltersPrice for_sales={for_sales} filters={filters} submitRef={submitRef} />
                    <SearchFormFiltersDistance distance={distance} submitRef={submitRef} />
                </div>
                {!for_sales && (<>
                    <div className="btn-custom-mod-wrapper" >
                        <CheckButton
                            name={"oneway_rental_true"}
                            display={"One-way Available"}
                            initialValue={filters?.oneway_rental_true}
                        />
                        <CheckButton
                            name={"handicap_accessible_true"}
                            display={"Wheelchair Accessible"}
                            initialValue={filters?.handicap_accessible_true}
                        />
                        <CheckButton
                            name={"user_rvrd_member_present"}
                            display={"RVRD Member"}
                            initialValue={filters?.user_rvrd_member_present}
                        />
                        <SearchFormFiltersBookableNowOnly show_bookable_now_only={show_bookable_now_only} submitRef={submitRef} />
                        <SearchFormFiltersReservableOnly show_reservable_only={show_reservable_only} submitRef={submitRef} />
                        <SearchFormFiltersDeliverableOnly show_deliverable_only={show_deliverable_only} submitRef={submitRef} />
                    </div>
                </>
                )}
                <div className='collapse-container'>
                    <div className='collapse-header'
                        onClick={() => setOpenVehicle(!openVehicle)}>
                        {openVehicle ? <FaArrowAltCircleUp color='white' /> : <FaArrowAltCircleDown color='white' />}
                        <label style={{ margin: "auto 10px" }}>Vehicle</label>
                    </div>
                    <Collapse in={openVehicle}>
                        <div className='collapse-body'>
                            <Form.Group controlId="vehicle_type_id_eq">
                                <Form.Label>Type</Form.Label>
                                <Form.Select className='form-control' name="q[vehicle_type_id_eq]" dangerouslySetInnerHTML={{ __html: '<option value="">Any</option>' + vehicle_types }}>
                                </Form.Select>
                            </Form.Group>
                            <Form.Group controlId="make_cont">
                                <Form.Label>Make</Form.Label>
                                <Form.Control type='text' placeholder='Make contains' name="q[make_cont]" defaultValue={filters.make_cont} />
                            </Form.Group>
                            <Form.Group controlId="model_cont">
                                <Form.Label>Model</Form.Label>
                                <Form.Control type='text' placeholder='Model contains' name="q[model_cont]" defaultValue={filters.model_cont} />
                            </Form.Group>
                            <Form.Group controlId="year_eq">
                                <Form.Label>Year</Form.Label>
                                <Form.Select className='form-control' name="q[year_eq]" defaultValue={filters.year_eq} >
                                    <option value="">Any</option>
                                    {Array(42).fill().map((_, idx) => new Date().getFullYear() - idx + 1).map((year, i) => <option key={i} value={year}>{year}</option>)}
                                </Form.Select>
                            </Form.Group>
                            <Form.Group>
                                <Form.Label style={{ width: "100%", marginTop: "10px" }}>Length <span className="note">(ft)</span></Form.Label>
                                <Form.Control type='text' name="q[vehicle_length_gteq]" value={minLen} onChange={() => { }} style={{ display: 'none' }} />
                                <Form.Control type='text' name="q[vehicle_length_lteq]" value={maxLen} onChange={() => { }} style={{ display: 'none' }} />
                                {minLen !== "" && maxLen !== "" && <Form.Label style={{ marginBottom: "0px" }}>{minLen}ft - {maxLen}ft</Form.Label>}
                                <MultiRangeSlider MIN={5} MAX={50} STEP={1} values={[minLen, maxLen]} setMinVal={setMinLen} setMaxVal={setMaxLen} />
                            </Form.Group>
                            <Form.Group>
                                <Form.Label style={{ width: "100%", marginTop: "10px" }}>Weight <span className="note">(lb)</span></Form.Label>
                                <Form.Control type='text' name="q[gvw_gteq]" value={minWeight} onChange={() => { }} style={{ display: 'none' }} />
                                <Form.Control type='text' name="q[gvw_lteq]" value={maxWeight} onChange={() => { }} style={{ display: 'none' }} />
                                {minWeight !== "" && maxWeight !== "" && <Form.Label style={{ marginBottom: "0px" }}>{minWeight}lb - {maxWeight}lb</Form.Label>}
                                <MultiRangeSlider MIN={1000} MAX={25000} STEP={1} values={[minWeight, maxWeight]} setMinVal={setMinWeight} setMaxVal={setMaxWeight} />
                            </Form.Group>
                        </div>
                    </Collapse>
                </div>
                <div className='collapse-container'>
                    <div className='collapse-header'
                        onClick={() => setOpenAccommodations(!openAccommodations)}>
                        {openAccommodations ? <FaArrowAltCircleUp color='white' /> : <FaArrowAltCircleDown color='white' />}
                        <label style={{ margin: "auto 10px" }}>Accommodations</label>
                    </div>
                    <Collapse in={openAccommodations}>
                        <div className='collapse-body'>
                            <Form.Group controlId="slides_eq">
                                <Form.Label>Slides</Form.Label>
                                <Form.Select className='form-control' name="q[slides_eq]" defaultValue={filters.slides_eq} >
                                    <option value="">Any</option>
                                    {Array(5).fill().map((_, idx) => idx + 1).map((cnt, i) => <option key={i} value={cnt}>{cnt}</option>)}
                                </Form.Select>
                            </Form.Group>
                            <Form.Group controlId="seatbelts_gteq">
                                <Form.Label>Minimum Seatbelts</Form.Label>
                                <Form.Select className='form-control' name="q[seatbelts_gteq]" defaultValue={filters.seatbelts_gteq} >
                                    <option value="">Any</option>
                                    {Array(8).fill().map((_, idx) => idx + 1).map((cnt, i) => <option key={i} value={cnt}>{cnt}</option>)}
                                </Form.Select>
                            </Form.Group>
                            <Form.Group controlId="accommodate_gteq" style={{ marginBottom: "16px" }}>
                                <Form.Label>Sleeps Minimum</Form.Label>
                                <Form.Select className='form-control' name="q[accommodate_gteq]" defaultValue={filters.accommodate_gteq} >
                                    <option value="">Any</option>
                                    {Array(8).fill().map((_, idx) => idx + 1).map((cnt, i) => <option key={i} value={cnt}>{cnt}</option>)}
                                </Form.Select>
                            </Form.Group>
                            {!for_sales && (
                                <CustomCheck
                                    id="pets_allowed_true"
                                    name="q[pets_allowed_true]"
                                    label="Pet Friendly"
                                    initialValue={filters?.pets_allowed_true}
                                />
                            )}
                        </div>
                    </Collapse>
                </div>
                <div className='collapse-container'>
                    <div className='collapse-header'
                        onClick={() => setOpenFeatures(!openFeatures)}>
                        {openFeatures ? <FaArrowAltCircleUp color='white' /> : <FaArrowAltCircleDown color='white' />}
                        <label style={{ margin: "auto 10px" }}>Features</label>
                    </div>
                    <Collapse in={openFeatures}>
                        <div className='collapse-body'>
                            <h3>Indoor</h3>
                            <Row>
                                <Col md={6}>
                                    <CustomCheck
                                        id="roof_air_true"
                                        name="q[roof_air_true]"
                                        label="Roof Air"
                                        initialValue={filters?.roof_air_true}
                                    />
                                </Col>
                                <Col md={6}>
                                    <CustomCheck
                                        id="stove_true"
                                        name="q[stove_true]"
                                        label="Stove"
                                        initialValue={filters?.stove_true}
                                    />
                                </Col>
                                <Col md={6}>
                                    <CustomCheck
                                        id="shower_true"
                                        name="q[shower_true]"
                                        label="Shower"
                                        initialValue={filters?.shower_true}
                                    />
                                </Col>
                                <Col md={6}>
                                    <CustomCheck
                                        id="wash_basin_true"
                                        name="q[wash_basin_true]"
                                        label="Wash Basin"
                                        initialValue={filters?.wash_basin_true}
                                    />
                                </Col>
                                <Col md={6}>
                                    <CustomCheck
                                        id="cd_true"
                                        name="q[cd_true]"
                                        label="CD"
                                        initialValue={filters?.cd_true}
                                    />
                                </Col>
                                <Col md={6}>
                                    <CustomCheck
                                        id="factory_cab_air_true"
                                        name="q[factory_cab_air_true]"
                                        label="Factory Cab Air"
                                        initialValue={filters?.factory_cab_air_true}
                                    />
                                </Col>
                                <Col md={6}>
                                    <CustomCheck
                                        id="refrigerator_true"
                                        name="q[refrigerator_true]"
                                        label="Refrigerator"
                                        initialValue={filters?.refrigerator_true}
                                    />
                                </Col>
                                <Col md={6}>
                                    <CustomCheck
                                        id="tv_dvd_true"
                                        name="q[tv_dvd_true]"
                                        label="TV/DVD"
                                        initialValue={filters?.tv_dvd_true}
                                    />
                                </Col>
                                <Col md={6}>
                                    <CustomCheck
                                        id="kitchen_sink_true"
                                        name="q[kitchen_sink_true]"
                                        label="Kitchen Sink"
                                        initialValue={filters?.kitchen_sink_true}
                                    />
                                </Col>
                                <Col md={6}>
                                    <CustomCheck
                                        id="toilet_true"
                                        name="q[toilet_true]"
                                        label="Toilet"
                                        initialValue={filters?.toilet_true}
                                    />
                                </Col>
                                <Col md={6}>
                                    <CustomCheck
                                        id="fm_radio_true"
                                        name="q[fm_radio_true]"
                                        label="FM Radio"
                                        initialValue={filters?.fm_radio_true}
                                    />
                                </Col>
                                <Col md={6}>
                                    <CustomCheck
                                        id="rear_living_true"
                                        name="q[rear_living_true]"
                                        label="Rear Living"
                                        initialValue={filters?.rear_living_true}
                                    />
                                </Col>
                                <Col md={6}>
                                    <CustomCheck
                                        id="front_living_true"
                                        name="q[front_living_true]"
                                        label="Front Living"
                                        initialValue={filters?.front_living_true}
                                    />
                                </Col>
                                <Col md={6}>
                                    <CustomCheck
                                        id="front_kitchen_true"
                                        name="q[front_kitchen_true]"
                                        label="Front Kitchen"
                                        initialValue={filters?.front_kitchen_true}
                                    />
                                </Col>
                                <Col md={6}>
                                    <CustomCheck
                                        id="kitchen_dinnet_true"
                                        name="q[kitchen_dinnet_true]"
                                        label="Kitchen Dinnet"
                                        initialValue={filters?.kitchen_dinnet_true}
                                    />
                                </Col>
                                <Col md={6}>
                                    <CustomCheck
                                        id="kitchen_table_true"
                                        name="q[kitchen_table_true]"
                                        label="Kitchen Table"
                                        initialValue={filters?.kitchen_table_true}
                                    />
                                </Col>
                                <Col md={6}>
                                    <CustomCheck
                                        id="gps_navigation_true"
                                        name="q[gps_navigation_true]"
                                        label="GPS Navigation"
                                        initialValue={filters?.gps_navigation_true}
                                    />
                                </Col>
                                <Col md={6}>
                                    <CustomCheck
                                        id="satellite_radio_true"
                                        name="q[satellite_radio_true]"
                                        label="Satellite Radio"
                                        initialValue={filters?.satellite_radio_true}
                                    />
                                </Col>
                                <Col md={6}>
                                    <CustomCheck
                                        id="satellite_tv_true"
                                        name="q[satellite_tv_true]"
                                        label="Satellite TV"
                                        initialValue={filters?.satellite_tv_true}
                                    />
                                </Col>
                            </Row>
                            <h3>Outdoor</h3>
                            <Row>
                                <Col md={6}>
                                    <CustomCheck
                                        id="bbq_grill_true"
                                        name="q[bbq_grill_true]"
                                        label="BBQ/Grill"
                                        initialValue={filters?.bbq_grill_true}
                                    />
                                </Col>
                                <Col md={6}>
                                    <CustomCheck
                                        id="outside_kitchen_true"
                                        name="q[outside_kitchen_true]"
                                        label="Outside Kitchen"
                                        initialValue={filters?.outside_kitchen_true}
                                    />
                                </Col>
                                <Col md={6}>
                                    <CustomCheck
                                        id="outside_sink_true"
                                        name="q[outside_sink_true]"
                                        label="Outside Sink"
                                        initialValue={filters?.outside_sink_true}
                                    />
                                </Col>
                                <Col md={6}>
                                    <CustomCheck
                                        id="outside_tv_true"
                                        name="q[outside_tv_true]"
                                        label="Outside TV"
                                        initialValue={filters?.outside_tv_true}
                                    />
                                </Col>
                                <Col md={6}>
                                    <CustomCheck
                                        id="outside_refrigerator_true"
                                        name="q[outside_refrigerator_true]"
                                        label="Outside Refrigerator"
                                        initialValue={filters?.outside_refrigerator_true}
                                    />
                                </Col>
                                <Col md={6}>
                                    <CustomCheck
                                        id="outside_radio_true"
                                        name="q[outside_radio_true]"
                                        label="Outside Radio/stereo"
                                        initialValue={filters?.outside_radio_true}
                                    />
                                </Col>
                                <Col md={6}>
                                    <CustomCheck
                                        id="outside_shower_true"
                                        name="q[outside_shower_true]"
                                        label="Outside Shower"
                                        initialValue={filters?.outside_shower_true}
                                    />
                                </Col>
                                <Col md={6}>
                                    <CustomCheck
                                        id="arctic_package_true"
                                        name="q[arctic_package_true]"
                                        label="Arctic Package"
                                        initialValue={filters?.arctic_package_true}
                                    />
                                </Col>
                                <Col md={6}>
                                    <CustomCheck
                                        id="awning_true"
                                        name="q[awning_true]"
                                        label="Awning"
                                        initialValue={filters?.awning_true}
                                    />
                                </Col>
                                <Col md={6}>
                                    <CustomCheck
                                        id="balcony_true"
                                        name="q[balcony_true]"
                                        label="Balcony"
                                        initialValue={filters?.balcony_true}
                                    />
                                </Col>
                                <Col md={6}>
                                    <CustomCheck
                                        id="leveling_system_true"
                                        name="q[leveling_system_true]"
                                        label="Leveling System"
                                        initialValue={filters?.leveling_system_true}
                                    />
                                </Col>
                                <Col md={6}>
                                    <CustomCheck
                                        id="towing_package_true"
                                        name="q[towing_package_true]"
                                        label="Towing Package"
                                        initialValue={filters?.towing_package_true}
                                    />
                                </Col>
                                <Col md={6}>
                                    <CustomCheck
                                        id="wifi_true"
                                        name="q[wifi_true]"
                                        label="WiFi"
                                        initialValue={filters?.wifi_true}
                                    />
                                </Col>
                                <Col md={6}>
                                    <CustomCheck
                                        id="bike_rack_true"
                                        name="q[bike_rack_true]"
                                        label="Bike Rack"
                                        initialValue={filters?.bike_rack_true}
                                    />
                                </Col>
                                <Col md={6}>
                                    <CustomCheck
                                        id="trailer_true"
                                        name="q[trailer_true]"
                                        label="Trailer"
                                        initialValue={filters?.trailer_true}
                                    />
                                </Col>
                                <Col md={6}>
                                    <CustomCheck
                                        id="electric_generator_true"
                                        name="q[electric_generator_true]"
                                        label="Generator"
                                        initialValue={filters?.electric_generator_true}
                                    />
                                </Col>
                                <Col md={6}>
                                    <CustomCheck
                                        id="propane_tank_true"
                                        name="q[propane_tank_true]"
                                        label="Propane Tank"
                                        initialValue={filters?.propane_tank_true}
                                    />
                                </Col>
                            </Row>
                        </div>
                    </Collapse>
                </div>
            </div>
        </CustomModal >
    </>);
}

export default SearchFormFilters;